import style from './accordion-text.module.scss'

const AccordionText = (props:any) => {
    let {state} = props;
    return (
        <div className={style.text}>
            {state}
        </div>
    )
}


export default AccordionText;
